// List of all codemods
export const BUNDLE = [
  'v1/mastra-core-imports',
  'v1/runtime-context',
  'v1/mastra-plural-apis',
  'v1/not-implemented/mastra-required-id',
  'v1/agent-property-access',
  'v1/agent-voice',
  'v1/agent-processor-methods',
  'v1/agent-generate-stream-v-next',
  'v1/agent-abort-signal',
  'v1/not-implemented/agent-format-parameter',
  'v1/not-implemented/agent-to-step',
  'v1/voice-property-names',
  'v1/mcp-get-tools',
  'v1/mcp-get-toolsets',
  'v1/client-sdk-types',
  'v1/client-to-ai-sdk-format',
  'v1/client-offset-limit',
  'v1/client-get-memory-thread',
  'v1/experimental-auth',
  'v1/evals-run-experiment',
  'v1/evals-scorer-by-name',
  'v1/evals-prebuilt-imports',
  'v1/workflow-create-run-async',
  'v1/workflow-run-count',
  'v1/workflow-list-runs',
  'v1/workflow-stream-vnext',
  'v1/workflow-get-init-data',
  'v1/memory-query-to-recall',
  'v1/memory-vector-search-param',
  'v1/memory-message-v2-type',
  'v1/memory-readonly-to-options',
  'v1/storage-get-threads-by-resource',
  'v1/storage-list-messages-by-id',
  'v1/storage-postgres-schema-name',
  'v1/storage-get-messages-paginated',
  'v1/storage-list-workflow-runs',
  'v1/storage-list-threads-by-resource-to-list-threads',
  'v1/vector-pg-constructor',
  'v1/client-msg-function-args',
];
